import { Link } from "react-router-dom";
import { Card, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { FileSpreadsheet, LineChart, Package, Scale } from "lucide-react";

const links = [
  {
    href: "/reports/sales",
    title: "Sales register",
    desc: "Filters, pagination, Excel & PDF.",
    icon: FileSpreadsheet,
  },
  {
    href: "/reports/gstr1",
    title: "GSTR-1",
    desc: "B2B / B2C / B2CL / HSN tabs + Excel.",
    icon: Scale,
  },
  {
    href: "/reports/gstr3b",
    title: "GSTR-3B",
    desc: "Outward vs ITC summary + export.",
    icon: Scale,
  },
  {
    href: "/reports/stock",
    title: "Stock & expiry",
    desc: "Valuation, expiry window, movements.",
    icon: Package,
  },
  {
    href: "/reports/profit",
    title: "P&L",
    desc: "Revenue, COGS, by month/category/product.",
    icon: LineChart,
  },
];

export default function ReportsPage() {
  return (
    <div className="min-h-full space-y-6 bg-background p-6">
      <div className="rounded-2xl border border-border bg-card p-6 shadow-sm">
        <div className="flex items-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary/15 text-primary">
            <FileSpreadsheet className="h-5 w-5" />
          </div>
          <div>
            <h1 className="text-2xl font-semibold tracking-tight text-foreground">Reports</h1>
            <p className="text-sm text-muted-foreground">GST compliance and operations.</p>
          </div>
        </div>
      </div>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {links.map((l) => {
          const Icon = l.icon;
          return (
            <Link key={l.href} to={l.href} className="group">
              <Card className="h-full border-border bg-card shadow-sm transition-all hover:-translate-y-0.5 hover:shadow-md">
                <CardHeader>
                  <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-lg bg-primary/15 text-primary">
                    <Icon className="h-5 w-5" />
                  </div>
                  <CardTitle className="text-base text-foreground">{l.title}</CardTitle>
                  <CardDescription className="text-muted-foreground">{l.desc}</CardDescription>
                </CardHeader>
              </Card>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
